// extracted by mini-css-extract-plugin
export default {"subTitle":"SystemActionLog_subTitle__cXa7G","errorMessage":"SystemActionLog_errorMessage__CnqCd"};